import { ENV, SYSTEMS_NAMES } from '../constants';

import Utils from '../helpers/Utils';

import * as amplitude from '@amplitude/analytics-browser';
import AbstractSystem from './AbstractSystem';
import { IPrepareTrackParams, ITrackNewAnalytics } from '../Interfaces/Events';
import { Config } from '../Interfaces/Config';
import DataProvider from '../DataProvider';

export default class AmplitudeAnalytic extends AbstractSystem {
    private envMode: 'production' | 'stage' | 'feature' | 'develop';
    private releaseDate: unknown;

    constructor() {
        super(SYSTEMS_NAMES.amplitude, false);

        this.envMode = ENV.develop;
        this.releaseDate = 'default_date';
    }

    public init({ id, config }: { id: string; config?: Config }) {
        if (!this.getIsInit() && config) {
            if (!config) {
                DataProvider.handleError(new Error('Config is required'));

                return;
            }

            if (!config.releaseDate) {
                DataProvider.handleError(new Error('Release date is not defined'));

                return;
            }

            if (!config.envMode) {
                DataProvider.handleError(new Error('Env mode is not defined'));

                return;
            }

            Utils.setReleaseDate(config.releaseDate);

            this.envMode = config.envMode;
            this.releaseDate = config.releaseDate;

            amplitude.init(id);
            this.isInit = true;
        }
    }

    public async trackNew({ eventName, eventAction, eventData = {} }: ITrackNewAnalytics): Promise<void> {
        const trackParams = await this.prepareTrackParams({
            eventName,
            eventAction,
            eventData,
        });

        try {
            amplitude.track(eventName, trackParams);

            console.log(`Event ${eventName} successfully sent.`); // eslint-disable-line no-console
        } catch (err) {
            DataProvider.handleError(err);

            console.error(`Error while sending ${eventName}`);
            // @ts-ignore
            console.error(err, err.stack);
        }
    }

    public async setUserProperties(data: Record<string, amplitude.Types.ValidPropertyType | null | undefined>) {
        const identifyEvent = new amplitude.Identify();

        for (const key in data) {
            // @TODO added default empty string for `value`
            const value = data[key] || '';

            if (value !== null) {
                identifyEvent.set(key, value);
            } else {
                identifyEvent.unset(key);
            }
        }

        amplitude.identify(identifyEvent);

        const typeOfUserId = typeof data.user_id as unknown;

        if (typeOfUserId === 'string' || typeOfUserId === 'number') {
            amplitude.setUserId(String(data.user_id));
        }
    }

    private async prepareTrackParams({ eventName = 'purchase', eventAction, eventData }: IPrepareTrackParams) {
        const recordData = await Utils.getAnalyticData(eventName, eventAction);

        const finalRecordData = {
            ...recordData,
            ...eventData,
            mode: this.envMode,
            release_date: this.releaseDate,
        };

        console.log('BEFORE SEND TO AMPLITUDE DATA', finalRecordData); // eslint-disable-line no-console

        return finalRecordData;
    }
}
